export const TOUR_STEP_IDS = {
  CHECKLIST_BUTTON: 'checklist-button',
  START_DATE: 'start-date',
  DATE_ROW_CALENDAR: 'date-row-calendar',
  MONTH_PICKER: 'month-selection-month-picker',
  CALENDAR_BUTTON: 'month-selection-calendar-button',
  ORGANISATION: 'api-top-main-info',
  TAXES: 'api-top-taxes',
  TAXES_DATE: 'api-top-taxes-calendar',
  SELECT_MARKETPLACE: 'select-marketplace',
  MARKETPLACE_API: 'api-marketplace',
  FIRST_STAGE_FINISH: 'first-stage-finish',
  STAGE_2_INTRO: 'stage-2-intro',
  SELECT_BANK: 'select-bank',
  BANKS_API: 'api-bank',
  SAVE_SETTINGS: 'save-settings',
  WAREHOUSES: 'create-warehouse-button',
  COUNTERPARTIES: 'counterparty-create-button',
  SECOND_STAGE_FINISH: 'second-stage-finish',
  STAGE_3_INTRO: 'stage-3-intro',
  BANKS_AND_RULES: 'banks-table',
  BANKS_ALL: 'banks-all',
  BANKS_TABLE: 'banks-table-local',
  BANKS_ARTICLES: 'banks-table-articles',
  BANKS_RULES: 'banks-rules',
  RULES_ADD: 'rules-add',
  RULES_MODAL: 'rules-modal',
  RULES_ALL: 'rules-all',
  BANKS_AFTER_RULES: 'banks-after-rules',
  CASHBOXES: 'create-cashbox',
  CASHBOXES_MODAL: 'cashbox-modal',
  CASHBOXES_ADD: 'cashbox-add-operation',
  CASHBOXES_ALL: 'cashbox-all',
  TAXES_STAGE_3: 'taxes-stage-3',
  FULL_PL_FINISH: 'full-pl-finish',
  FULL_DDS_FINISH: 'full-dds-finish',
  LOAD_INITIAL_REMAINS: 'load-initial-remains',
  WAIT_FOR_INITIAL_REMAINS: 'wait-for-initial-remains',
  OPEN_ACCEPTANCE: 'open-acceptance',
  DOWNLOAD_ACCEPTANCE_TEMPLATE: 'download-acceptance-template',
  UPLOAD_ACCEPTANCE_TEMPLATE: 'upload-acceptance-template',
  FILL_ACCEPTANCE_INFORMATION: 'fill-acceptance-information',
  SAVE_ACCEPTANCE: 'save-acceptance',
  SAVE_ALL_ACCEPTANCES: 'save-all-acceptances',
  OPEN_SHIPMENT: 'open-shipment',
  FILL_SHIPMENT_INFORMATION: 'fill-shipment-information',
  SAVE_SHIPMENT: 'save-shipment',
  SAVE_ALL_SHIPMENTS: 'save-all-shipments',
} as const;
